// src/v2/components/DrawerCloseButton.jsx
//
// Canonical close button for all peek/slide drawers.
// 28×28 dark semi-transparent circle, white Lucide X icon, positioned
// absolute at top:10, right:10 — matches the Offices drawer reference style.
//
// Props:
//   onClick   function  — called when the button is clicked
//   testId    string?   — optional data-testid

import { X } from "lucide-react";
import { T } from "../../app/tokens.js";

export function DrawerCloseButton({ onClick, testId }) {
  return (
    <button
      type="button"
      aria-label="Close"
      onClick={onClick}
      data-testid={testId}
      style={{
        position:        "absolute",
        top:             10,
        right:           10,
        width:           28,
        height:          28,
        background:      "rgba(0,0,0,0.45)",
        border:          0,
        borderRadius:    "50%",
        display:         "flex",
        alignItems:      "center",
        justifyContent:  "center",
        cursor:          "pointer",
        color:           T.white,
      }}
    >
      <X size={14} />
    </button>
  );
}
